export default __webpack_public_path__ + "static/media/covidTracker.25fef876.PNG";